export const testimonials = [
  {
    id: 1,
    quote: "以前追韩漫要去好几个网站，现在一个平台全搞定！翻译质量也很棒，读起来特别流畅。",
    name: "漫游者小明",
    role: "大学生 · 2年用户",
    avatarUrl: "https://readdy.ai/api/search-image?query=Young%20Asian%20male%20portrait%2C%20casual%20modern%20style%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20photography&width=200&height=200&seq=avatar-user-01&orientation=squarish"
  },
  {
    id: 2,
    quote: "作为韩漫重度爱好者，这个平台真的拯救了我的书荒！推荐算法很精准，总能发现符合口味的新作品。",
    name: "樱花飘落时",
    role: "上班族 · 1年用户",
    avatarUrl: "https://readdy.ai/api/search-image?query=Young%20Asian%20female%20portrait%2C%20modern%20casual%20style%2C%20warm%20smile%2C%20simple%20neutral%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20photography&width=200&height=200&seq=avatar-user-02&orientation=squarish"
  },
  {
    id: 3,
    quote: "每天通勤路上必刷！手机阅读体验特别流畅，画质高清不卡顿。已经安利给身边所有喜欢看漫画的朋友了。",
    name: "柠檬不酸",
    role: "设计师 · 6个月用户",
    avatarUrl: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%2C%20creative%20casual%20style%2C%20genuine%20smile%2C%20simple%20light%20background%2C%20soft%20studio%20lighting%2C%20professional%20headshot%20photography&width=200&height=200&seq=avatar-user-03&orientation=squarish"
  }
];